export const CANCEL_EWAY_BILL_REPORT_REQUEST = 'CANCEL_EWAY_BILL_REPORT_REQUEST';
export const CANCEL_EWAY_BILL_REPORT_SUCCESS = 'CANCEL_EWAY_BILL_REPORT_SUCCESS';
export const CANCEL_EWAY_BILL_REPORT_FAILURE = 'CANCEL_EWAY_BILL_REPORT_FAILURE';